export default __webpack_public_path__ + "static/media/egg-hatch.908ed1a7.gif";